import SubmittedPayoutMasterForm from "../Components/Masters/PayoutMaster/SubmittedPayoutMasterForm";
import SIDDetails from "../Components/Masters/SidMaster/SIDDetails";
import SIDMerchantOnboarding from "../Components/Masters/SidMaster/SIDMerchantOnboarding";
import SIDSubmitted from "../Components/Masters/SidMaster/SIDSubmitted";
import BBPSMaster from "../Components/Masters/SidMaster/BBPSMaster";
import SIDList from "../Components/Masters/SidMaster/SidList";
import { MastersIcons } from "../Assets/images/image";

export const MastersRegistry = [
  {
    label: "Enabled SID's",
    key: "SIDSubmitted",
    requiredSub: "SID Master",
    component: SIDSubmitted,
    icon: MastersIcons.SIDSubmitted,
  },
  {
    label: "SID Details",
    key: "SIDDetails",
    requiredSub: "SID Master",
    component: SIDDetails,
    icon: MastersIcons.SIDDetails,
  },
  {
    label: "SID Merchant Onboarding",
    key: "SIDMerchantOnboarding",
    requiredSub: "Sid Merchant  Onboarding",
    component: SIDMerchantOnboarding,
    icon: MastersIcons.Onboarding,
  },
  {
    label: "Payout Master Form",
    key: "SubmittedPayoutMasterForm",
    requiredSub: "Payout Master",
    component: SubmittedPayoutMasterForm,
    icon: MastersIcons.MastersForm,
  },
  {
    label: "BBPS Master",
    key: "BBPSMaster",
    requiredSub: "BBPS Master",
    component: BBPSMaster,
    icon: MastersIcons.BBPSMaster,
  },
  {
    label: "Create SID",
    key: "sidCreation",
    requiredSub: "SID Creation View",
    component: SIDList,
    icon: MastersIcons.createSidImage,
  },
];
